import { Plugin } from '@ckeditor/ckeditor5-core';
export default class RawHtmlUI extends Plugin {
    init() { }
}
